"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeConditions = exports.getNodeForArticle = exports.passesConditions = exports.examplePricingPlan = exports.conditionConfig = exports.ConditionTypesEnum = exports.ConditionStrictness = void 0;
var types_1 = require("../../types");
var ConditionStrictness;
(function (ConditionStrictness) {
    ConditionStrictness["atleastOne"] = "atleastOne";
    ConditionStrictness["all"] = "all";
})(ConditionStrictness = exports.ConditionStrictness || (exports.ConditionStrictness = {}));
var ConditionTypesEnum;
(function (ConditionTypesEnum) {
    ConditionTypesEnum["Printing"] = "printing";
    ConditionTypesEnum["Expansion"] = "expansion";
    ConditionTypesEnum["Language"] = "language";
    ConditionTypesEnum["PriceGuide"] = "priceGuide";
    ConditionTypesEnum["CardExtra"] = "cardExtra";
    ConditionTypesEnum["CardCondition"] = "cardCondition";
    ConditionTypesEnum["Comment"] = "comment";
    ConditionTypesEnum["Quantity"] = "quantity";
    ConditionTypesEnum["Rarity"] = "rarity";
    ConditionTypesEnum["Price"] = "price";
})(ConditionTypesEnum = exports.ConditionTypesEnum || (exports.ConditionTypesEnum = {}));
var uniqueArray = function (arr, getId) {
    return Array.from(new Set(arr.map(getId))).map(function (id) {
        return arr.find(function (val) { return getId(val) === id; });
    });
};
var cardNameConfig = {
    isValid: function (condition) {
        return condition.type === ConditionTypesEnum.Printing &&
            Array.isArray(condition.value) &&
            condition.value.filter(function (_a) {
                var _id = _a._id;
                return _id;
            }).length > 0;
    },
    articleFits: function (article, condition) {
        var fits = condition.value.map(function (_a) {
            var _id = _a._id;
            return _id;
        }).includes(article.card._id);
        return condition.negated ? !fits : fits;
    },
    negatable: true,
    stack: function (existingCondition, newCondition) {
        return __assign(__assign({}, existingCondition), { value: uniqueArray(__spreadArray(__spreadArray([], existingCondition.value, true), newCondition.value, true), function (val) { return val._id; }) });
    },
};
var languageConfig = {
    isValid: function (condition) {
        return condition.type === ConditionTypesEnum.Language &&
            Array.isArray(condition.value) &&
            condition.value.filter(function (language) { return types_1.CardLanguage[language]; }).length > 0;
    },
    articleFits: function (article, condition) {
        var fits = condition.value.includes(article.idLanguage);
        return condition.negated ? !fits : fits;
    },
    negatable: true,
    stack: function (existingCondition, newCondition) {
        return __assign(__assign({}, existingCondition), { value: uniqueArray(__spreadArray(__spreadArray([], existingCondition.value, true), newCondition.value, true), function (val) { return val; }) });
    },
};
var expansionConfig = {
    isValid: function (condition) {
        return condition.type === ConditionTypesEnum.Expansion &&
            Array.isArray(condition.value) &&
            condition.value.filter(function (expansion) { return expansion._id && expansion.name; }).length > 0;
    },
    articleFits: function (article, condition) {
        var fits = condition.value.map(function (_a) {
            var code = _a.code;
            return code;
        }).includes(article.card.set);
        return condition.negated ? !fits : fits;
    },
    negatable: true,
    stack: function (existingCondition, newCondition) {
        return __assign(__assign({}, existingCondition), { value: uniqueArray(__spreadArray(__spreadArray([], existingCondition.value, true), newCondition.value, true), function (val) { return val._id; }) });
    },
};
var priceGuideConfig = {
    articleFits: function (article, condition, priceGuide) {
        var _a, _b, _c, _d;
        var attribute = (article.isShiny ? "Foil".concat(condition.value.metric) : "".concat(condition.value.metric));
        //todo implement
        var guideValue = priceGuide && priceGuide[attribute];
        if (!guideValue)
            return false;
        return (guideValue >= ((_b = (_a = condition.value) === null || _a === void 0 ? void 0 : _a.min) !== null && _b !== void 0 ? _b : 0) && guideValue <= ((_d = (_c = condition.value) === null || _c === void 0 ? void 0 : _c.max) !== null && _d !== void 0 ? _d : Infinity));
    },
    isValid: function (condition) {
        var _a, _b, _c, _d, _e, _f, _g;
        return !!(condition.type === ConditionTypesEnum.PriceGuide &&
            (Number((_a = condition.value) === null || _a === void 0 ? void 0 : _a.min) >= 0 || Number((_b = condition.value) === null || _b === void 0 ? void 0 : _b.max) < 10000000) &&
            Number((_d = (_c = condition.value) === null || _c === void 0 ? void 0 : _c.min) !== null && _d !== void 0 ? _d : 0) < Number((_f = (_e = condition.value) === null || _e === void 0 ? void 0 : _e.max) !== null && _f !== void 0 ? _f : Infinity) &&
            Object.values(types_1.PriceGuideMetrics).includes((_g = condition.value) === null || _g === void 0 ? void 0 : _g.metric));
    },
};
var cardExtraConfig = {
    articleFits: function (article, condition) {
        var passesForEveryAttribute = !Object.values(types_1.CardExtraAttribute).filter(function (attribute) {
            if (condition.value[attribute] === types_1.AnyYesNo.Any)
                return false;
            return Boolean(condition.value[attribute]) !== Boolean(article[attribute]);
        }).length;
        return passesForEveryAttribute;
    },
    isValid: function (condition) {
        if (condition.type !== ConditionTypesEnum.CardExtra)
            return false;
        var hasValidValueForEachAttribute = !!Object.values(types_1.CardExtraAttribute).filter(function (attribute) {
            return [0, 1, 'any'].includes(condition.value[attribute]);
        }).length;
        if (!hasValidValueForEachAttribute)
            return false;
        var hasAtLeastOneNonAnyAttribute = !!Object.values(types_1.CardExtraAttribute).filter(function (attribute) {
            return [types_1.AnyYesNo.No, types_1.AnyYesNo.Yes].includes(condition.value[attribute]);
        }).length;
        return hasAtLeastOneNonAnyAttribute;
    },
};
var cardConditionConfig = {
    articleFits: function (article, condition) {
        var _a, _b;
        return (types_1.ConditionEnum[article.condition] >= ((_a = condition.value.min) !== null && _a !== void 0 ? _a : types_1.ConditionEnum.MT) &&
            types_1.ConditionEnum[article.condition] <= ((_b = condition.value.max) !== null && _b !== void 0 ? _b : types_1.ConditionEnum.PO));
    },
    isValid: function (condition) {
        return (condition.type === ConditionTypesEnum.CardCondition &&
            (typeof condition.value.min === 'number' || typeof condition.value.max === 'number'));
    },
};
var rarityConfig = {
    articleFits: function (article, condition) {
        return article.card.rarity >= condition.value.min && article.card.rarity <= condition.value.max;
    },
    isValid: function (condition) {
        return (condition.type === ConditionTypesEnum.Rarity &&
            (typeof condition.value.min === 'number' || typeof condition.value.max === 'number'));
    },
};
var commentCondition = {
    articleFits: function (article, condition) {
        var fits = article.comment.includes(condition.value);
        return condition.negated ? !fits : fits;
    },
    isValid: function (condition) {
        return (condition.type === ConditionTypesEnum.Comment &&
            typeof condition.value === 'string' &&
            condition.value.length > 0);
    },
    allowMultipleOfSameType: true,
    negatable: true,
};
var quantityCondition = {
    articleFits: function (article, condition) {
        var _a, _b;
        var fits = article.quantity >= ((_a = condition.value.min) !== null && _a !== void 0 ? _a : 0) &&
            article.quantity <= ((_b = condition.value.max) !== null && _b !== void 0 ? _b : Infinity);
        return condition.negated ? !fits : fits;
    },
    isValid: function (condition) {
        return (condition.type === ConditionTypesEnum.Quantity &&
            (condition.value.min > 1 || condition.value.max < 24));
    },
    allowMultipleOfSameType: false,
    negatable: false,
};
var PriceCondition = {
    articleFits: function (article, condition) {
        var _a, _b;
        var fits = article.price >= ((_a = condition.value.min) !== null && _a !== void 0 ? _a : 0) &&
            article.price <= ((_b = condition.value.max) !== null && _b !== void 0 ? _b : Infinity);
        return condition.negated ? !fits : fits;
    },
    isValid: function (condition) {
        var _a, _b, _c, _d, _e, _f;
        return !!(condition.type === ConditionTypesEnum.Price &&
            (Number((_a = condition.value) === null || _a === void 0 ? void 0 : _a.min) >= 0 || Number((_b = condition.value) === null || _b === void 0 ? void 0 : _b.max) < 10000000) &&
            Number((_d = (_c = condition.value) === null || _c === void 0 ? void 0 : _c.min) !== null && _d !== void 0 ? _d : 0) < Number((_f = (_e = condition.value) === null || _e === void 0 ? void 0 : _e.max) !== null && _f !== void 0 ? _f : Infinity));
    },
    allowMultipleOfSameType: false,
    negatable: false,
};
exports.conditionConfig = (_a = {},
    _a[ConditionTypesEnum.Printing] = cardNameConfig,
    _a[ConditionTypesEnum.CardExtra] = cardExtraConfig,
    _a[ConditionTypesEnum.Expansion] = expansionConfig,
    _a[ConditionTypesEnum.Language] = languageConfig,
    _a[ConditionTypesEnum.PriceGuide] = priceGuideConfig,
    _a[ConditionTypesEnum.CardCondition] = cardConditionConfig,
    _a[ConditionTypesEnum.Comment] = commentCondition,
    _a[ConditionTypesEnum.Quantity] = quantityCondition,
    _a[ConditionTypesEnum.Rarity] = rarityConfig,
    _a[ConditionTypesEnum.Price] = PriceCondition,
    _a);
exports.examplePricingPlan = {
    _id: '1423',
    idGame: types_1.IdGame.Magic,
    name: 'Pricing Plan',
    settings: {
        maxValueDecrease: 5,
        maxValueIncrease: 50,
        maxValueIncreaseEnabled: true,
    },
    defaultNode: {
        id: 'default',
        method: 'Undercut German Profi',
    },
    nodes: [
        {
            id: '1231das',
            conditionStrictness: ConditionStrictness.atleastOne,
            method: 'Standard',
            conditions: [
                {
                    id: '432',
                    type: ConditionTypesEnum.CardExtra,
                    value: (_b = {},
                        _b[types_1.CardExtraAttribute.FirstEd] = types_1.AnyYesNo.Any,
                        _b[types_1.CardExtraAttribute.Foil] = types_1.AnyYesNo.Any,
                        _b[types_1.CardExtraAttribute.Signed] = types_1.AnyYesNo.Any,
                        _b[types_1.CardExtraAttribute.ReverseHolo] = types_1.AnyYesNo.Any,
                        _b[types_1.CardExtraAttribute.Playset] = types_1.AnyYesNo.Any,
                        _b),
                },
            ],
            children: [
                {
                    id: '123d1das',
                    conditionStrictness: ConditionStrictness.atleastOne,
                    method: 'Standard JP',
                    conditions: [
                        {
                            id: '41232',
                            type: ConditionTypesEnum.Language,
                            value: [types_1.CardLanguage.Japanese],
                        },
                    ],
                    children: [],
                },
                {
                    id: '12sa31das',
                    conditionStrictness: ConditionStrictness.atleastOne,
                    method: 'Standard Other Lang',
                    conditions: [
                        {
                            id: '44332',
                            type: ConditionTypesEnum.Language,
                            value: [types_1.CardLanguage.English],
                            negated: true,
                        },
                    ],
                    children: [],
                },
            ],
        },
        {
            id: '1231daews',
            conditionStrictness: ConditionStrictness.atleastOne,
            method: 'IGNORE',
            conditions: [
                {
                    id: '1232',
                    type: ConditionTypesEnum.PriceGuide,
                    value: { min: 5, metric: 'AVG1' },
                },
                {
                    id: '4342112',
                    type: ConditionTypesEnum.PriceGuide,
                    value: { max: 100, metric: 'Trend' },
                },
            ],
            children: [],
        },
    ],
};
var fitsCondition = function (article, condition, priceGuide) {
    return exports.conditionConfig[condition.type].articleFits(article, condition, priceGuide);
};
var passesConditions = function (conditions, strictness, article, priceGuide) {
    if (strictness === ConditionStrictness.all) {
        for (var _i = 0, conditions_1 = conditions; _i < conditions_1.length; _i++) {
            var condition = conditions_1[_i];
            var fits = fitsCondition(article, condition, priceGuide);
            if (!fits)
                return false;
        }
        return true;
    }
    else {
        for (var _a = 0, conditions_2 = conditions; _a < conditions_2.length; _a++) {
            var condition = conditions_2[_a];
            var fits = fitsCondition(article, condition, priceGuide);
            if (fits)
                return true;
        }
        return false;
    }
};
exports.passesConditions = passesConditions;
var getNodeForArticle = function (plan, article, priceGuide) {
    var activeNode = plan.defaultNode;
    var findNodeInBranch = function (branch) {
        if (branch === void 0) { branch = []; }
        for (var i = 0; i < branch.length; i++) {
            if ((0, exports.passesConditions)(branch[i].conditions, branch[i].conditionStrictness, article, priceGuide)) {
                activeNode = branch[i];
                if (branch[i].children) {
                    findNodeInBranch(branch[i].children);
                }
                break;
            }
        }
    };
    findNodeInBranch(plan.nodes);
    return activeNode;
};
exports.getNodeForArticle = getNodeForArticle;
var mergeConditions = function (conditionToMerge, existingConditions) {
    if (exports.conditionConfig[conditionToMerge.type].allowMultipleOfSameType) {
        return __spreadArray(__spreadArray([], existingConditions, true), [conditionToMerge], false);
    }
    var existingConditionOfSameType = existingConditions.find(function (_a) {
        var type = _a.type;
        return type === conditionToMerge.type;
    });
    if (!existingConditionOfSameType)
        return __spreadArray(__spreadArray([], existingConditions, true), [conditionToMerge], false);
    var stackFn = exports.conditionConfig[conditionToMerge.type].stack;
    if (!stackFn)
        throw new Error('cannotStackThisConditionType');
    if (!!existingConditionOfSameType.negated !== !!conditionToMerge.negated)
        throw new Error('cannotStackConditionsWithDifferentNegation');
    //@ts-ignore
    var newCondition = stackFn(existingConditionOfSameType, conditionToMerge);
    //@ts-ignore
    return existingConditions.map(function (condition) {
        if (condition.type !== newCondition.type)
            return condition;
        return newCondition;
    });
};
exports.mergeConditions = mergeConditions;
//# sourceMappingURL=pricingPlan.js.map